import {
  postCardConfigDemo1TawkPill,
  PostCard,
} from "../Components/PostCard/PostCard";

function Sandbox(): JSX.Element {
  return PostCard(postCardConfigDemo1TawkPill);
}

export default Sandbox;
